import React from 'react';
// Mui components
import { Box, Radio, Tooltip, Typography } from '@mui/material';

function CardDirecciones({ consultorio, elegido, setElegido }) {

    const handleClick = () => {
        setElegido(consultorio);
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: 3, padding: 1, marginBottom: '10px', width: '70%', maxWidth: '530px',
                ...(elegido?.consultorioId === consultorio.consultorioId && {
                    backgroundColor: '#E7E9F7',
                    borderColor: '#E7E9F7'
                }),
                '&:hover': {
                    backgroundColor: '#E7E9F7',
                    cursor: 'pointer',
                },
            }}
        >
            <Radio
                checked={elegido?.consultorioId === consultorio.consultorioId}
                value={consultorio}
            />
            <Tooltip title={consultorio.direccion} placement='top-end'>
                <Typography variant='bodyS'>
                    {consultorio.direccion}
                </Typography>
            </Tooltip>
        </Box>
    );
}

export default CardDirecciones;
